var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import './BaseCalendarBodyContent.scss';
import BaseCalendarMonth from './BaseCalendarMonth';
import BaseCalendarWeek from './BaseCalendarWeek';
function BaseCalendarBodyContent(props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get mode() {
            return p.state.mode;
        },
        get startDate() {
            return p.state.startDate;
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var ContentRenderer = (function () {
                switch (s.mode) {
                    case 'week': return function () { return React.createElement(BaseCalendarWeek, __assign({}, props)); };
                    case 'month': return function () { return React.createElement(BaseCalendarMonth, __assign({}, props)); };
                    default: return null;
                }
            })();
            return (p.state.shouldDisplayAsTimeline ? (React.createElement("div", { className: "BaseCalendarBodyContent" },
                React.createElement("div", { className: "BaseCalendarBodyContentInner" }, ContentRenderer && React.createElement(ContentRenderer, null)))) : (React.createElement("table", { className: "BaseCalendarBodyContent" },
                React.createElement("tbody", { className: "BaseCalendarBodyContentInner" }, ContentRenderer && React.createElement(ContentRenderer, null)))));
        } });
}
export default BaseCalendarBodyContent;
